// app
export const ROUTE_SWITCHING = 'ROUTE_SWITCHING'

// account
export const SET_ACCOUNT = 'SET_ACCOUNT'
export const RETRIEVE_ACCOUNT = 'RETRIEVE_ACCOUNT'

// auth
// 检查是否已获得认证,若是则设置状态和http认证头
export const CHECK_AUTHENTICATION = 'CHECK_AUTHENTICATION'
// 获得认证:设置状态,保存token,设置http认证头
export const OBTAIN_AUTHENTICATION = 'OBTAIN_AUTHENTICATION'
// 清除认证:清除状态,清除token,清除http认证头
export const CLEAR_AUTHENTICATION = 'CLEAR_AUTHENTICATION'

// appointments
export const SET_APPOINTMENT_LIST_TAB_INDEX = 'SET_APPOINTMENT_LIST_TAB_INDEX'
export const SET_APPOINTMENT_PAY_TAB_INDEX = 'SET_APPOINTMENT_PAY_TAB_INDEX'

// appointments
export const SET_EM_APPOINTMENT_LIST_TAB_INDEX = 'SET_EM_APPOINTMENT_LIST_TAB_INDEX'

export const SET_SPECIAL_CLINIC_SCHEDULE_TAB_INDEX = 'SET_SPECIAL_CLINIC_SCHEDULE_TAB_INDEX'

export const SET_INOUT_HOSPITAL_SCHEDULE_TAB_INDEX = 'SET_INOUT_HOSPITAL_SCHEDULE_TAB_INDEX'

export const SET_ACTIVITY_TAB_INDEX = 'SET_ACTIVITY_TAB_INDEX'

export const SET_NAD_TAB_INDEX = 'SET_NAD_TAB_INDEX'

// mes
export const SET_ORDER_LIST_TAB_INDEX = 'SET_ORDER_LIST_TAB_INDEX'

export const SET_MAIL_APPLICATION_TAB_INDEX = 'SET_MAIL_APPLICATION_TAB_INDEX'

// pretty_tibet
export const SET_PRETTY_TIBET_LIST_TAB_INDEX = 'SET_PRETTY_TIBET_LIST_TAB_INDEX'

export const FIRST_MENU = 'FIRST_MENU'

export const PAGE_SAVE = 'PAGE_SAVE'

export const DEBUG_MODE = 'DEBUG_MODE'

export const SET_ORDER_SIGN_TAB_INDEX = 'SET_ORDER_SIGN_TAB_INDEX'

export const SET_FF_PATIENT = 'SET_FF_PATIENT'

export const SET_PRE_DIAGNOSIS_TAB_INDEX = 'SET_PRE_DIAGNOSIS_TAB_INDEX'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js